import '../app.ts'
import '/@front:css/views/register.css'
import '/@front:css/views/properties.apply.css'

import { mountPage } from '/@front:shared/mount-page'

mountPage(
  {
    name: 'register',
  },
  { telInput: true },
)
